module.exports = __webpack_public_path__ + "images/bannerES-23aacd785b6553f068c6634ec9f4691e.jpg";